import React from 'react';

const iconProps = {
  width: 28,
  height: 28,
  viewBox: '0 0 28 28',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true
};

export const FabricIcon = () => (
  <svg {...iconProps}>
    <path d="M4 8h20M4 14h20M4 20h20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <rect x="6" y="5" width="16" height="18" rx="1" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const ComfortIcon = () => (
  <svg {...iconProps}>
    <path
      d="M14 4c-4 0-7 2.5-7 6v8c0 3.5 3 6 7 6s7-2.5 7-6v-8c0-3.5-3-6-7-6z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M10 12h8M10 16h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const FitIcon = () => (
  <svg {...iconProps}>
    <path
      d="M8 22V10l6-4 6 4v12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M11 22v-6h6v6" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

export const BreathIcon = () => (
  <svg {...iconProps}>
    <path
      d="M6 14c2-4 5-6 8-6s6 2 8 6c-2 4-5 6-8 6s-6-2-8-6z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle cx="14" cy="14" r="2" fill="currentColor" />
  </svg>
);

export const ConfidenceIcon = () => (
  <svg {...iconProps}>
    <path d="M14 4l2 5h5l-4 3 1.5 5L14 14l-4.5 3L11 12 7 9h5l2-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

export const StyleIcon = () => (
  <svg {...iconProps}>
    <rect x="5" y="6" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
    <path d="M9 6V4h10v2M14 12v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const LUXURY_ICONS = {
  fabric: FabricIcon,
  comfort: ComfortIcon,
  fit: FitIcon,
  breath: BreathIcon,
  confidence: ConfidenceIcon,
  style: StyleIcon
};
